/**
 * @param {!jQuery} $main
 * @param {Function=} success
 */
window['HelenQuoteLoad'] = function ($main, success) {
    success = typeof success === 'function' ? success : $.noop;

	$main.parent().css({'overflow': 'hidden'});
	const HelenQuoteID = /** @type {string} */ ($main.attr('data-helen-quote-id'));

	Ajax({
		'scope': $main,
		'url': '/helen/quote',
		'data': {
			'HelenQuoteID': HelenQuoteID,
			'Step': $main.attr('data-helen-quote-step')
		},
		'success': function (/** Object<string,?> */ data) {
            $main.html(data['content']);

            gtm(':helen.quote.load');

			const p = $main.find('.helen-quote-option-sub-products').length === 0;
			const a = $main.find('.helen-quote-option-artwork-options').length !== 0;
            const Horizontal = $main.find('.helen-quote-option-horizontal').length !== 0;
            const AutoScroll = $main.find('.helen-quote-option-auto-scroll').length !== 0;

			const $start = $main.find('.helen-quote-start');
			const $end = $main.find('.helen-quote-end');

			const $parent = $main.find('.helen-quote-form-parent');
			const $steps = $start.find('.helen-quote-steps');

			const START = 0;
			const END = 5;

			const $doc = $(document);

			/**
			 * @param {number} s
			 */
			const Step = function (s) {
				$parent.removeClass('helen-quote-form-parent-start helen-quote-form-parent-end');
				switch (s) {
				case START:
					$parent.addClass('helen-quote-form-parent-start');
					$doc.trigger(':helen.quote.start');
					// window.location.hash = "#start";
					break;
				case END:
					$parent.addClass('helen-quote-form-parent-end');
					$doc.trigger(':helen.quote.end');
					// window.location.hash = "#end";
					break;
				}

                // if (AutoScroll) {
                //     setTimeout(function () {
                //         $("html, body").animate({'scrollTop': 0}, 150);
                //     });
                // }
			}

			if ($parent.hasClass('helen-quote-form-parent-start')) {
				Step(START);
			} else if ($parent.hasClass('helen-quote-form-parent-end')) {
				Step(END);
			}

			// let /** string */ hash = window.location.hash;
			// // let /** string */ lastHash = hash;
			// const CheckHash = setInterval(function () {
			// 	if (window.location.hash !== hash) {
			// 		// lastHash = hash;
			// 		hash = window.location.hash;
			// 		if (hash === '#end') {
			// 			clearInterval(CheckHash);
			// 			return;
			// 		}
			// 		// alert("User went back or forward to application state represented by " + hash);
			// 		switch (hash) {
			// 		case '#start':
			// 			Step(START);
			// 			break;
			// 		}
			// 	}
			// }, 100);

			$main.find('input[type="tel"]').each(/** @this {Element} */ function () {
				const $this = $(this);
				$this.data('iti', intlTelInput(this, {
					'dropdownContainer': document.body,
					'separateDialCode': true,
					'autoPlaceholder': 'aggressive',
					'utilsScript': 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
					'customPlaceholder': function (/** string */ selectedCountryPlaceholder, _) {
						return "e.g. " + selectedCountryPlaceholder;
					},
				}));
				setTimeout(function () {
					$this.attr('autocomplete', 'tel-national');
				});
			});

			const $Phone = $start.find('.helen-quote-phone-input');
			let PhoneIti = /** @type {!iti} */ ($Phone.data('iti'));

			if (!Mobile()) {
				try {
					datepicker($start.find('.helen-quote-date-needed-input').attr('type', 'text')[0], {
						'minDate': new Date(),
                        'startDate': new Date(),
                        'position': 'tl',
						'onSelect': function () {
							$start.find('.helen-quote-date-needed-input').trigger('input');
						}
					});
				} catch (_) {}
			}

			let QuantityChanged = false;

			const SetQuantityToMinimum = function () {
                if ($main.is('[data-disable-minimum-quantity]')) {
                    return;
                }

                if (/** @type {boolean} */ (QuantityChanged) && /** @type {boolean} */ ($start.find('.helen-quote-minimum-quantity-text').length === 0)) {
                    return;
                }

				Ajax({
					url: '/helen/getminimumquantity',
					data: {
						'HelenQuoteID': HelenQuoteID,
						'LineItem': !a ? $start.find('.helen-quote-product-select').val() : $start.find('[name="helen-checkout-product"]:checked').val(),
						'Type': !a ? $start.find('.helen-quote-type-select').val() : $start.find('[name="helen-checkout-type"]:checked').val(),
					},
					success: function (/** Object<string,*> */ d) {
                        $start.find('.helen-quote-minimum-quantity-text').text(String(/** @type {Number} */ (d['minimumquantity'])));

                        if (QuantityChanged) {
                            return;
                        }

						$start.find('.helen-quote-quantity-input').val(String(/** @type {Number} */ (d['minimumquantity'])));
					}
				});
			}

			ImageUpload({
				dropZone: $start,
				button: $start.find('.helen-quote-artwork-image-upload-button'),
				input: '.helen-quote-artwork-image-upload-input',
				template: '.helen-quote-artwork-image-template',
				deleteLink: '.helen-quote-artwork-image-delete-link',
				image: '.helen-quote-artwork-image',
                parent: '.helen-quote-artwork-images',
                link: '.helen-quote-artwork-image-link',
			});

			/**
			 * @param {!jQuery} $e
			 */
			function NextQuoteStep($e) {
				const $Step = $e.closest('.helen-quote-step-parent');
				let $Next = $Step.nextAll('.helen-quote-step-parent:not(.disabled)').filter((_, e) => {
                    const $optionsParent = $(e).find('.helen-quote-artwork-options-parent');
                    if ($optionsParent.length === 0) {
                        return true;
                    }

                    const $options = $optionsParent.children().not('.d-none');
                    if ($options.length === 0) {
                        return false;
                    }

                    return true;
                }).eq(0);
				if (Horizontal) {
					$start.find('.helen-quote-step-parent.helen-quote-step-parent-active').removeClass('helen-quote-step-parent-active');
					$steps.css('left', String(parseInt($steps[0]['style']['left'], 10) - 100) + '%');
					$Step.find('.helen-quote-step-next-button').removeClass('d-none');
				}

				if ($Next.length === 0) {
					$Next = $start.find('.helen-quote-step-parent').eq(-1);
				}

				if (Horizontal) {
					$Next.addClass('helen-quote-step-parent-active');
				}

				if (Horizontal || $Next.hasClass('d-none')) {
					$Next.removeClass('d-none')
					const $Selected = $Next.find('.helen-quote-artwork-option:not(.d-none) :checked');
					if ($Selected.length !== 0) {
						NextQuoteStep($Selected);
					} else if (AutoScroll) {
						ScrollTo($Next);
					}
                }
                $doc.trigger(':helen.quote.step.next');
			}

			if (!a) {
				const $Products = $start.find('.helen-quote-product-select');
				const $Types = $start.find('.helen-quote-type-select');
				const $Sizes = $start.find('.helen-quote-size-select');
				const $Children = $start.find('.helen-quote-child-select');

				if (p) {
					$Types.on('change', /** @this {Element} */ function () {
						const $this = $(this);
						$Sizes.resetOptions().find('[data-line-item-type-id]:not([data-line-item-type-id="' + /** @type {string} */($this.val()) + '"])').hideOptions();
						if ($Sizes.find('[data-line-item-type-id]').length === 0) {
							$Sizes.removeAttr('required').parent().addClass('d-none');
						} else {
							$Sizes.attr('required', true).parent().removeClass('d-none');
						}

						SetQuantityToMinimum();
					}).trigger('change');
				}

				const TypeAttr = p ? 'data-line-item-id': 'data-network-sub-line-item-id';

				$Products.on('change', /** @this {Element} */ function () {
					const $this = $(this);
					$Types.resetOptions().find('['+TypeAttr+']:not(['+TypeAttr+'="' + /** @type {string} */($this.val()) + '"])').hideOptions();
					if ($Types.find('['+TypeAttr+']').length === 0) {
						$Types.removeAttr('required').parent().addClass('d-none');
					} else {
						$Types.attr('required', true).parent().removeClass('d-none');
					}

					if (!p) {
						$Sizes.resetOptions().find('[data-network-sub-line-item-id]:not([data-network-sub-line-item-id="' + /** @type {string} */($this.val()) + '"])').hideOptions();
						if ($Sizes.find('[data-network-sub-line-item-id]').length === 0) {
							$Sizes.removeAttr('required').parent().addClass('d-none');
						} else {
							$Sizes.attr('required', true).parent().removeClass('d-none');
						}
					}

					$Children.removeAttr('required').parent().addClass('d-none').find('input').attr('disabled', true);
					$Children.filter('['+TypeAttr+'="' + /** @type {string} */($this.val()) + '"]').attr('required', true).parent().removeClass('d-none').find('input').removeAttr('disabled');

					SetQuantityToMinimum();
				}).trigger('change');

				$start.find('select').on('change', /** @this {Element} */ function () {
					const $this = $(this);

					if ($this.val() === 'other') {
						const $i = $this.nextAll('input').eq(0);
						$i.removeClass('d-none').attr('required', true);
						setTimeout(function () {
							$i.trigger('focus');
						});
					} else {
						$this.nextAll('input').eq(0).addClass('d-none').removeAttr('required');
					}
				});
			} else {
				const attr = p ? 'data-line-item-id' : 'data-network-sub-line-item-id';
				const $Types = $start.find('.helen-quote-types-parent .helen-quote-artwork-option');
				const $Sizes = $start.find('.helen-quote-artwork-size-options>.helen-quote-artwork-option');
				const $ChildOptions = $start.find('.helen-quote-artwork-child-options['+attr+']');

				$start.find('.helen-checkout-product-radio').on('click', /** @this {Element} */ function () {
					$start.find('.helen-quote-step-parent:not(.helen-quote-products-parent)').addClass('d-none');
					const id = /** @type {string} */ ($start.find('input[name="helen-checkout-product"]:checked').val());
					$ChildOptions.closest('.helen-quote-step-parent').addClass('disabled');
					$ChildOptions.filter('['+attr+'="'+id+'"]').closest('.helen-quote-step-parent').removeClass('disabled');
					const $ActiveTypes = $Types.filter('['+attr+'="'+id+'"]').removeClass('d-none');
					$Types.not($ActiveTypes).addClass('d-none');
					if ($Types.not('.d-none').length === 0) {
						$start.find('.helen-quote-types-parent').addClass('disabled');
					} else {
						$start.find('.helen-quote-types-parent').removeClass('disabled');
					}

					if (!p) {
						const $ActiveSizes = $Sizes.filter('[data-network-sub-line-item-id="'+id+'"]').removeClass('d-none');
						// console.log($ActiveSizes, $Sizes);
						$Sizes.not($ActiveSizes).addClass('d-none');
					}

					SetQuantityToMinimum();

					NextQuoteStep($(this));
				});

				$start.find('.helen-checkout-type-radio').on('click', /** @this {Element} */ function () {
					if (p) {
						const t = /** @type {string} */ ($start.find('input[name="helen-checkout-type"]:checked').val());
						const $ActiveSizes = $Sizes.filter('[data-line-item-type-id="'+t+'"]').removeClass('d-none');
						$Sizes.not($ActiveSizes).addClass('d-none');
					}

					SetQuantityToMinimum();

					NextQuoteStep($(this));
				});

				$start.find('.helen-checkout-size-radio').on('click', /** @this {Element} */ function () {
					NextQuoteStep($(this));
				});

				$start.find('.helen-quote-artwork-child-options input').on('click', /** @this {Element} */ function () {
					NextQuoteStep($(this));
				});

				$start.find('.helen-quote-step-back-button').on('click', /** @this {Element} */ function () {
					const $Step = $(this).closest('.helen-quote-step-parent');
					const $Prev = $Step.prevAll('.helen-quote-step-parent:not(.disabled)').eq(0);
					$start.find('.helen-quote-step-parent.helen-quote-step-parent-active').removeClass('helen-quote-step-parent-active');
					if (Horizontal) {
						$steps.css('left', String(parseInt($steps[0]['style']['left'], 10) + 100) + '%');
					}

					if ($Prev.length !== 0) {
                        $Prev.addClass('helen-quote-step-parent-active');
                        if (AutoScroll) {
                            ScrollTo($Prev);
                        }
                    }
                    $doc.trigger(':helen.quote.step.prev');
				});

				$start.find('.helen-quote-step-next-button').on('click', /** @this {Element} */ function () {
					NextQuoteStep($(this));
				});

				$start.find('.helen-quote-final-step-back-button').on('click', /** @this {Element} */ function () {
					const $Prev = $start.find('.helen-quote-steps .helen-quote-step-parent:not(.disabled)').eq(-1);
					$start.find('.helen-quote-step-parent.helen-quote-step-parent-active').removeClass('helen-quote-step-parent-active');
					if (Horizontal) {
						$steps.css('left', String(parseInt($steps[0]['style']['left'], 10) + 100) + '%');
                    }
                    $Prev.addClass('helen-quote-step-parent-active')
                    if (AutoScroll) {
                        ScrollTo($Prev);
                    }
                    $start.find('.helen-quote-step-parent').eq(-1).addClass('d-none');
                    $doc.trigger(':helen.quote.step.prev');
				});
            }

            const $budgetInput = $start.find('.helen-quote-budget-input');
            const $quantityInput = $start.find('.helen-quote-quantity-input');

			$start.find('.helen-quote-form').on('submit', async function (/** Event */ e) {
				e.preventDefault();

				const $Controls = $start.find('input,select,button,a,textarea');
				const l = Ladda.create($start.find('.helen-quote-continue-button')[0]);
				l.start();
				$Controls.attr('disabled', true);

				Ajax({
					scope: $start,
					url: '/helen/newquoterequest',
					data: {
						'HelenQuoteID': HelenQuoteID,
						'FormSubmissionID': $start.find('.helen-quote-form-input').val(),
						'LineItem': !a ? $start.find('.helen-quote-product-select').val() : $start.find('[name="helen-checkout-product"]:checked').val(),
						'LineItemOther': !a ? $start.find('.helen-quote-product-select').nextAll('input').eq(0).val() : undefined,
						'Type': !a ? $start.find('.helen-quote-type-select').val() : $start.find('[name="helen-checkout-type"]:checked').val(),
						'TypeOther': !a ? $start.find('.helen-quote-type-select').nextAll('input').eq(0).val() : undefined,
						'Size': !a ? $start.find('.helen-quote-size-select').val() : $start.find('[name="helen-checkout-size"]:checked').val(),
						'SizeOther': !a ? $start.find('.helen-quote-size-select').nextAll('input').eq(0).val() : undefined,
						'FullName': $start.find('.helen-quote-full-name-input').val(),
						'Company': $start.find('.helen-quote-company-input').val(),
						// 'AddressLine1': $start.find('.helen-quote-address-line-1-input').val(),
						// 'AddressLine2': $start.find('.helen-quote-address-line-2-input').val(),
						// 'City': $start.find('.helen-quote-city-input').val(),
						'CountryID': $start.find('.helen-quote-country-select').val(),
						// 'StateID': $start.find('.helen-quote-state-select').val(),
						'Zip': $start.find('.helen-quote-zip-input').val(),
                        'Phone': PhoneIti.getNumber(),
                        '_Phone': $start.find('.helen-quote-phone-input').val(),
						'Email': $start.find('.helen-quote-email-input').val(),
						'ArtworkImageIDs': $start.find('.helen-quote-artwork-image').map(/** @this {Element} */ function () { return $(this).attr('data-image-id') }).get(),
                        'DateNeeded': $start.find('.helen-quote-date-needed-input').val(),
                        'PromotionalCode': $start.find('.helen-quote-promo-input').val(),
						'Notes': ($start.find('.helen-quote-field-input').filter(/** @this {Element} */ function () {
							return !$(this).closest('.form-group').hasClass('d-none');
						}).map(/** @this {Element} */ function () {
							const $this = $(this);
							const v = /** @type {string} */ ($this.val());
							return /** @type {string} */ ($this.attr('placeholder')) + ': ' + (!strempty(v) ? v : 'Not Given');
						}).get().join('\n') + '\n\n' +
						/** @type {string} */ ($start.find('.helen-quote-notes').val()).trim()).trim(),
                        'Quantity': $start.find('.helen-quote-quantity-input').val(),
                        'Budget': $budgetInput.val(),
						'ChildLineItems': !a ? $start.find('.form-group:not(.d-none)>.helen-quote-child-select').map(/** @this {Element} **/ function () {
							const $this = $(this);
							return {
								'ChildLineItemID': $this.attr('name'),
								'ChildLineItemOptionID': $this.val(),
								'Option': $this.nextAll('input').eq(0).val()
							};
						}).get() :
						$start.find('.helen-quote-child-parent:not(.disabled) :checked').map(/** @this {Element} **/ function () {
							const $this = $(this);
							return {
								'ChildLineItemID': $this.closest('.helen-quote-artwork-child-options').attr('name'),
								'ChildLineItemOptionID': $this.val(),
							};
						}).get(),
						'PageRequestID': (await window['GetPageRequestID']?.()) || (typeof window['PageRequestXHR'] === 'object' && window['PageRequestXHR'] !== null &&
                            'responseText' in window['PageRequestXHR'] ? String(window['PageRequestXHR']['responseText']) : null),
                        'UserRoleOptionID': $start.find('.helen-quote-user-role-option-select').val(),
                        'Project': $start.find('.helen-quote-project-input').val(),
                        'SMS': $start.find('.helen-quote-sms-checkbox').is(':checked'),
                        'tz': new Intl.DateTimeFormat().resolvedOptions().timeZone,
					},
					success: function (/** Object<string,*> */ data) {
                        const fullName = $start.find('.helen-quote-full-name-input').val();
                        const names = fullName.split(' ');
                        const firstName = names.shift() || '';
                        const lastName = names.join(' ');
                        const dataLayer = /** @type {Array<*>} */(window['dataLayer']) || [];
                        let event = 'helen-quote-request-form-success';

                        if (event === 'https://signaturecoins.com/freequote' ||
                            event === 'https://signaturepins.com/freequote' ||
                            event === 'https://signaturepatches.com/freequote' ||
                            event === 'https://signaturelanyards.com/freequote') {
                            event = 'spg-visual-helen-request-form-success';
                        }

                        dataLayer.push({
                            'event': event,
                            'userData': {
                                'email': $start.find('.helen-quote-email-input').val(),
                                'phone': PhoneIti.getNumber(),
                                'firstName': firstName,
                                'lastName': lastName,
                            },
                            'transactionId': data['quoteid'],
                            // 'products': gtmProducts,
                            'total': data['total'],
                            'helenQuoteID': HelenQuoteID,
                        });

                        const successPageLink = $end.attr('data-success-page');
                        if (successPageLink) {
                            gtm(':helen.quote.newquoterequest.success');
                            window.location = `${successPageLink}?id=${data['quotehash']}`;
                        } else {
                            $end.find('.helen-quote-details-parent').html(/** @type {string} */ (data['details']));
                            $end.find('.helen-quote-first-name').text(/** @type {string} */ (data['firstname']));
                            $end.find('.helen-quote-email').text(/** @type {string} */ (data['email']));
                            $parent.removeClass('helen-quote-form-parent-start').addClass('helen-quote-form-parent-end');
                            Step(END);
                            setTimeout(function () {
                                $Controls.removeAttr('disabled');
                                l.stop();
                            }, 100);
                            const FormID = /** @type {string} */ (data['formsubmissionid']);
                            if (!strempty(FormID)) {
                                $start.find('.helen-quote-form-input').val(FormID);
                            }
                            gtm(':helen.quote.newquoterequest.success');
                        }
					},
					error: function (_, /** Object<string,*> */ resp) {
						$Controls.removeAttr('disabled');
						l.stop();
						const FormID = /** @type {string} */ (resp['formsubmissionid']);
						if (!strempty(FormID)) {
							$start.find('.helen-quote-form-input').val(FormID);
                        }
                        // gtm(':helen.quote.newquoterequest.error');
                        $main.trigger(':helen.quote.newquoterequest.error');
					}
				});
            });

            $end.find('.helen-quote-new-quote-button').on('click', function () {
                Step(START);
                $main.find('.helen-quote-form').trigger('reset');
                $start.find('.helen-quote-classic-form-parent select').trigger('change');
                $start.find('.helen-quote-artwork-image-delete-link').trigger('click');
                QuantityChanged = false;
            });

			if (a) {
				const $Options = $start.find('.helen-quote-artwork-option');
				const $Radios = $Options.find('input');
				$Radios.on('click', /** @this {Element} */ function () {
					const $this = $(this);
					const $p = $this.closest('.helen-quote-artwork-option');

					$p.addClass('active').siblings().removeClass('active');

					const fields = $start.find('.helen-quote-info-parent .form-group [data-parent]');
					fields.closest('.form-group').addClass('d-none');
					fields.filter(/** @this {Element} */ function () {
						return $Radios.filter('[value="'+/** @type {string} */($(this).attr('data-parent'))+'"]:checked').length !== 0
                    }).closest('.form-group').removeClass('d-none');

                    gtm(':helen.quote.click.'+/** @type {string} */($this.closest('.helen-quote-step-parent').attr('data-name')).class());
				});
			}

			$main.find('.helen-quote-field-input.helen-quote-color-input').each(/** @this {Element} */ function () {
				const $this = $(this);
				let Swatches = [];
				if (typeof $this.attr('data-swatches') === 'string') {
					Swatches = $this.attr('data-swatches').split(',')
				}
				$this.minicolors({
					'swatches': Swatches
				});
			});

			$start.find('.helen-quote-quantity-input').on('input', function () {
				QuantityChanged = true;
            });

            $start.find('.helen-quote-promo-input').on('input', /** @this {Element} */ function () {
                Ajax({
                    url: '/helen/getpromocode',
                    data: {
                        'Code': $(this).val()
                    },
                    success: function (/** Object<string,?> */ data) {
                        const desc = /** @type {string} */ (data['description']);
                        const name = /** @type {string} */ (data['name']);
                        if (!strempty(name)) {
                            $start.find('.helen-quote-promo-details').removeClass('d-none');
                            $start.find('.helen-quote-promo-name').text(name);
                            if (!strempty(desc)) {
                                $start.find('.helen-quote-promo-description-parent').removeClass('d-none');
                                $start.find('.helen-quote-promo-description').text(desc);
                            } else {
                                $start.find('.helen-quote-promo-description-parent').addClass('d-none');
                            }
                        } else {
                            $start.find('.helen-quote-promo-details').addClass('d-none');
                        }
                    }
                });
            });

            if (typeof $_GET['promo'] === 'string') {
                $start.find('.helen-quote-promo-input').val($_GET['promo']).trigger('input');
            }

            const $budgetHelpText = $start.find('.helen-quote-budget-help-text');
            const $budgetUnitCost = $start.find('.helen-quote-budget-help-text-unit-cost');

            const updateBudgetUnitCost = function () {
                const quantity = GetDigits(String($quantityInput.val()));
                const budget = GetDigits(String($budgetInput.val()));

                if (quantity > 0 && budget > 0) {
                    $budgetUnitCost.text(dollar_format(String(budget/quantity)));
                    $budgetHelpText.removeClass('d-none');
                } else {
                    $budgetHelpText.addClass('d-none');
                }
            }

            $quantityInput.on('input', updateBudgetUnitCost);
            $budgetInput.on('input', updateBudgetUnitCost);

            $main.trigger(':helen.quote.loaded');
            /** @type {Element} */($main[0]).dispatchEvent(new CustomEvent(":helen.quote.loaded", {}));

            success();
		},
	});
};

$('.helen-quote-parent').each(/** @this {Element} */ function () {
    window['HelenQuoteLoad']($(this));
});

/**
 * @param {string} Name
 * @param {string} LineItem
 * @param {string=} Type
 * @param {string=} Size
 * @param {Object<string,string>=} Children
 */
window['SetHelenQuoteFields'] = function (Name, LineItem, Type, Size, Children) {
    Type = typeof Type === 'string' ? Type : '';
    Size = typeof Size === 'string' ? Size : '';
    Children = typeof Children === 'object' && Children !== null ? Children : {};

    const $h = $('.helen-quote-parent[data-helen-name="'+Name+'"]');

    const $p = $h.find('.helen-quote-product-select');
    $p.val(LineItem);
    if ($p.val() === null) {
        $p.find('option').each(/** @this {Element} */ function () {
            this.selected = (this.text === LineItem);
        });
    }
    if ($p.val() === null) {
        $p.val('');
    }
    $p.trigger('change');

    const $t = $h.find('.helen-quote-type-select');
    $t.val(Type);
    if ($t.val() === null) {
        $t.find('option').each(/** @this {Element} */ function () {
            this.selected = (this.text === Type);
        });
    }
    if ($t.val() === null) {
        $t.val('');
    }
    $t.trigger('change');

    const $s = $h.find('.helen-quote-size-select');
    $s.val(Size);
    if ($s.val() === null) {
        $s.find('option').each(/** @this {Element} */ function () {
            this.selected = (this.text === Size);
        });
    }
    if ($s.val() === null) {
        $s.val('');
    }
    $s.trigger('change');
};